export const blockIconsHomeRollerShades = (
	<span className='material-symbols-outlined'>roller_shades</span>
);
